export interface JerseySportLike {
  jersey_type_id?: string | number | null
}

export interface JerseyGameLike {
  generic_sport_id?: string | number | null
}

/**
 * The JerseyPattern key for a game (1 soccer / 2 hockey / 3 basketball): the
 * sport's `jersey_type_id` — the generic (basic-stats) sport's when the game
 * has one, otherwise the full-stats sport's. Not the raw `sport_id`, which is a
 * hashed id JerseyPattern can't key on. Shared by web + mobile.
 */
export const getJerseyPatternId = (
  game: JerseyGameLike | null | undefined,
  sport: JerseySportLike | null | undefined,
  genericSport: JerseySportLike | null | undefined
): string | number | undefined =>
  (game?.generic_sport_id
    ? genericSport?.jersey_type_id
    : sport?.jersey_type_id) ?? undefined
